import type { Route } from '@angular/router';

import { ConditionalGuard } from '@guards/conditional.guard';
import { BEHEER_ROLES } from '@config/beheer-roles';

// NOTE: when adding any extra routes, make sure these are added to staticwebapp.config.json too
// there is a whitelist in place there to have everything else fall back to 404.
export const appChildrenRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'leerlingen',
    pathMatch: 'full',
  },
  {
    path: 'leerlingen',
    data: {
      label: 'LEERLINGEN',
    },
    loadChildren: () => import('@features/leerlingen').then((m) => m.doorstroomtoetsDoeFeatureLeerlingenRoutes),
  },
  {
    path: 'downloads',
    canActivate: [ConditionalGuard],
    data: {
      label: 'DOWNLOADS',
      featureKey: 'downloads',
      deniedToast: {
        summary: 'Downloads niet beschikbaar',
        messageKey: 'TOASTER_MESSAGES.DOWNLOADS_AVAILABLE_ERROR',
      },
    },
    loadChildren: () => import('@features/download/src').then((m) => m.doorstroomtoetsDoeFeatureDownloadRoutes),
  },
  {
    path: 'plannen',
    data: {
      label: 'PLANNEN',
    },
    loadChildren: () => import('@features/plannen').then((m) => m.doorstroomtoetsDoeFeaturePlannenRoutes),
  },
  {
    path: 'voorbereidingstoets',
    canActivate: [ConditionalGuard],
    data: {
      label: 'VOORBEREIDINGSTOETS',
      featureKey: 'voorbereidingstoets',
      deniedToast: {
        summary: 'Voorbereidingstoets niet beschikbaar',
        messageKey: 'TOASTER_MESSAGES.VOORBEREIDINGSTOETS_AVAILABLE_ERROR',
      },
    },
    loadChildren: () => import('@features/voorbereidingstoets').then((m) => m.voorbereidingstoetsRoutes),
  },
  {
    path: 'schrijfvaardigheid',
    canActivate: [ConditionalGuard],
    data: {
      label: 'SCHRIJFVAARDIGHEID',
      featureKey: 'schrijfvaardigheid',
      deniedToast: {
        summary: 'Schrijfvaardigheidstoets niet beschikbaar',
        messageKey: 'TOASTER_MESSAGES.SCHRIJFVAARDIGHEID_AVAILABLE_ERROR',
      },
    },
    loadChildren: () => import('@features/schrijfvaardigheid').then((m) => m.schrijfvaardigheidRoutes),
  },
  {
    path: 'rapportages',
    canActivate: [ConditionalGuard],
    data: {
      label: 'RAPPORTAGE',
      availabilityKey: 'rapportages',
      deniedToast: {
        summary: 'Rapportages niet beschikbaar',
        messageKey: 'TOASTER_MESSAGES.RAPPORTEN_AVAILABLE_ERROR',
      },
    },
    loadChildren: () => import('@features/rapportage').then((m) => m.doorstroomtoetsDoeFeatureRapportageRoutes),
  },
  {
    path: 'beheer',
    canActivate: [ConditionalGuard],
    data: {
      label: 'BEHEER',
      requiredRoles: BEHEER_ROLES,
      deniedToast: {
        summary: 'Geen toegang',
        messageKey: 'ERRORS.ACCESS_DENIED',
      },
    },
    loadChildren: () => import('@features/beheer').then((m) => m.doorstroomtoetsDoeFeatureBeheerRoutes),
  },
];
